import { SubmissionData, SubmissionEntityInterface } from '@types';

export const handleDate = (submission: SubmissionEntityInterface): SubmissionEntityInterface => {
  const submissionData = JSON.parse(submission.data);
  if (submissionData && submissionData.date) {
    const newData: SubmissionData = { ...submissionData.data, date: new Date() };
    return { ...submission, data: JSON.stringify(newData) };
  } else {
    return { ...submission };
  }
};
